query MobileSdkTestSummary($runId: ConditionID!) {
	msdk_report_runs(run_id_eq: $runId) {
		total_scans
		total_issues
		critical_issues
	}
	issues(run_id_eq: $runId, deleted_eq: { value: false }) {
		tickets__key
	}
	androidScans: scans(run_id_eq: $runId, os_eq: { value: ["ANDROID"] }) {
		os_count
	}
	iosScans: scans(run_id_eq: $runId, os_eq: { value: ["IOS"] }) {
		os_count
	}
}

